import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import dayjs from 'dayjs'
import { ISellerCancelPenalty } from 'models/orders'

// Четвёртая отмена за 30 дней отключает магазин на 14 дней — продавцу сообщаем сразу после отмены
export const showSellerDisabledModal = (penalty?: ISellerCancelPenalty | null) => {
  if (!penalty?.disabled) {
    return
  }

  Modal.warning({
    centered: true,
    title: 'Магазин отключён',
    content: penalty.disabled_until
      ? `Из-за отмен заказов ваш магазин отключён на 14 дней — до ${dayjs(penalty.disabled_until).format('DD.MM.YYYY HH:mm')}. После этого он включится автоматически`
      : 'Из-за отмен заказов ваш магазин отключён на 14 дней. После этого он включится автоматически',
    icon: <ExclamationCircleOutlined />,
    okText: 'Понятно'
  })
}
